export default function () {
  if (!window || !window.process || !window.process.env || !window.process.env.NODE_ENV !== 'production') {
    return false
  }

  return true
}
